import { useState, useEffect } from 'react';

export const useDeviceSize = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: windowWidth < 768,
    isTablet: windowWidth >= 768 && windowWidth < 1024,
    isTabletPortrait: windowWidth >= 768 && windowWidth < 900,
    isDesktop: windowWidth >= 1024,
    windowWidth,
  };
};
